export default __webpack_public_path__ + "pypi/streamlit-1.35.0-cp311-none-any.whl";